import classNames from 'classnames';
import { ModalAnchorTrigger } from 'components/shared/ModalAnchorTrigger/ModalAnchorTrigger';
import { WorkflowErrorDetailsModal } from 'components/shared/WorkflowError/WorkflowErrorDetailsModal';
import { WorkflowErrorSummary } from 'components/shared/WorkflowError/WorkflowErrorSummary';
import { useAppSelector } from 'hooks/useAppSelector';
import { useIsInternalUser } from 'hooks/useIsInternalUser';
import { FormattedMessage } from 'react-intl';
import { useQuote } from 'routes/essential-workspace/hooks/use-quote';
import { selectEssentialQuoteRejection } from 'routes/essential-workspace/state/form.selectors';
import { selectEssentialFormInfos } from 'state/essential/infos/selectors';

export function QuoteError() {
  const { formId, textColor } = useQuote();
  const isInternalUser = useIsInternalUser();
  const errors = useAppSelector(state => selectEssentialQuoteRejection(state, formId));
  const productSubtype = useAppSelector(State => selectEssentialFormInfos(State, formId)?.productDescription);

  const shouldDisplayStandardErrorMessage = !isInternalUser;
  const hasErrors = errors && errors.length > 0;

  return (
    <div className={classNames('text-start py-2', textColor)}>
      {shouldDisplayStandardErrorMessage && (
        <p className="text-break">
          <FormattedMessage id="errorDetails.standardMessage" />
        </p>
      )}
      <WorkflowErrorSummary
        shouldUseRejectionCode={!isInternalUser}
        workflowErrors={errors}
        productSubtype={productSubtype}
      />
      {hasErrors && (
        <div className="mt-4 mb-2">
          <ModalAnchorTrigger id={`errors-panel-details-button`} text="seeErrorDetails">
            {({ isOn, toggle }) => (
              <WorkflowErrorDetailsModal
                errors={errors}
                isOpen={isOn}
                shouldDisplayErrorDetails={isInternalUser}
                toggle={toggle}
              />
            )}
          </ModalAnchorTrigger>
        </div>
      )}
    </div>
  );
}
